import React from 'react';
import { TrendingUpIcon, GraduationCapIcon, AwardIcon, UsersIcon, CheckCircleIcon, ArrowRightIcon, CircleIcon, CheckIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const Careers = () => {
  return <div className="w-full pt-24" data-id="element-203">
      {/* Hero Section - Updated with new content */}
      <section className="bg-primary py-20 relative overflow-hidden" data-id="element-204">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-205"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-206">
          <div className="max-w-4xl mx-auto text-center" data-id="element-207">
            <h1 className="text-white font-bold mb-8 text-4xl md:text-5xl leading-tight" data-id="element-208">
              Not just a job. A mission. A legacy. A community.
            </h1>

            <p className="text-white text-lg md:text-xl leading-relaxed mb-10 max-w-3xl mx-auto opacity-95" data-id="element-209">
              At Magnavera Group, you don't just build a career—you become part
              of a movement that transforms lives, strengthens families, and
              creates lasting impact across generations.
            </p>

            <div className="space-y-4 mb-12 max-w-2xl mx-auto" data-id="element-210">
              <div className="flex items-start text-left" data-id="element-211">
                <CircleIcon size={8} className="text-[#8B6914] fill-[#8B6914] mr-4 mt-2 flex-shrink-0" data-id="element-212" />
                <p className="text-white text-lg" data-id="element-213">
                  <span className="font-semibold" data-id="element-214">Empower families</span> to
                  make confident financial decisions
                </p>
              </div>
              <div className="flex items-start text-left" data-id="element-215">
                <CircleIcon size={8} className="text-[#8B6914] fill-[#8B6914] mr-4 mt-2 flex-shrink-0" data-id="element-216" />
                <p className="text-white text-lg" data-id="element-217">
                  <span className="font-semibold" data-id="element-218">
                    Build meaningful relationships
                  </span>{' '}
                  grounded in trust and integrity
                </p>
              </div>
              <div className="flex items-start text-left" data-id="element-219">
                <CircleIcon size={8} className="text-[#8B6914] fill-[#8B6914] mr-4 mt-2 flex-shrink-0" data-id="element-220" />
                <p className="text-white text-lg" data-id="element-221">
                  <span className="font-semibold" data-id="element-222">Create a legacy</span> that
                  extends beyond your own success
                </p>
              </div>
            </div>

            <Button href="/contact" className="bg-white text-primary hover:bg-gray-100 px-8 py-4 text-lg font-semibold inline-flex items-center" data-id="element-223">
              Build a career that creates real impact
              <ArrowRightIcon size={20} className="ml-2" data-id="element-224" />
            </Button>
          </div>
        </div>
      </section>

      {/* Why Join Magnavera - Updated Content */}
      <section className="py-16" data-id="element-225">
        <div className="container mx-auto px-4" data-id="element-226">
          <div className="max-w-6xl mx-auto" data-id="element-227">
            <div className="text-center mb-12" data-id="element-228">
              <span className="inline-block text-primary font-semibold mb-2 uppercase tracking-wider text-sm" data-id="element-229">
                Why Join Magnavera
              </span>
              <h2 className="font-bold mb-6 text-3xl" data-id="element-230">
                Build a Meaningful, Purpose-Led Career
              </h2>
              <div className="w-20 h-1 bg-primary mx-auto mb-6" data-id="element-231"></div>
              <p className="text-text-secondary text-lg leading-relaxed max-w-3xl mx-auto mb-4" data-id="element-232">
                At Magnavera Group, you're not just selling policies—you're
                empowering families to take control of their financial futures.
                You'll guide clients through life's biggest decisions, help them
                protect what matters most, and create strategies that last for
                generations.
              </p>
              <p className="text-lg leading-relaxed font-bold text-[#8B6914]" data-id="element-233">
                You'll become the financial champion every family wishes they
                had.
              </p>
            </div>

            <div className="bg-white p-8 md:p-10 rounded-lg shadow-lg" data-id="element-234">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-235">
                <div data-id="element-236">
                  <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Financial Advisors Team" className="rounded-lg shadow-md w-full h-full object-cover" data-id="element-237" />
                </div>
                <div className="space-y-6" data-id="element-238">
                  <h3 className="font-bold text-2xl mb-6" data-id="element-239">What We Offer</h3>
                  {[{
                  title: 'Comprehensive Training & Development',
                  description: 'Master the fundamentals and advanced strategies through hands-on coaching and structured learning.'
                }, {
                  title: 'Mentorship from Industry Leaders',
                  description: 'Learn directly from top advisors who have built successful, sustainable practices.'
                }, {
                  title: 'Unlimited Earning Potential',
                  description: 'Your income grows with your impact—no caps, no limits, just opportunity.'
                }, {
                  title: 'Work-Life Flexibility',
                  description: 'Design a schedule that works for you while building meaningful client relationships.'
                }, {
                  title: 'Recognition & Rewards',
                  description: 'Celebrate milestones with MDRT qualifications, leadership awards, and incentive trips.'
                }, {
                  title: 'Career Advancement Opportunities',
                  description: 'Grow from advisor to team leader to agency builder—your path is yours to shape.'
                }].map((item, index) => <div key={index} className="flex items-start" data-id="element-240">
                      <CheckIcon className="text-primary flex-shrink-0 mr-3 mt-1" size={20} data-id="element-241" />
                      <div data-id="element-242">
                        <p className="font-bold text-gray-900 mb-1" data-id="element-243">
                          {item.title}
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-244">
                          {item.description}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>

            <div className="text-center mt-10" data-id="element-245">
              <Button href="https://www.greateasternlife.com/sg/en/careers/financial-representative/apply-now.html" target="_blank" rel="noopener noreferrer" className="px-8 py-4" data-id="element-246">
                Apply Now
                <ArrowRightIcon size={16} className="ml-2" data-id="element-247" />
              </Button>
              <p className="text-sm text-text-secondary mt-4" data-id="element-248">
                Take the first step towards a rewarding career in financial
                advisory.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits - Updated with black text color */}
      <section className="py-16 bg-background" data-id="element-249">
        <div className="container mx-auto px-4" data-id="element-250">
          <div className="text-center mb-12" data-id="element-251">
            <h2 className="font-bold mb-4" data-id="element-252">Benefits of Joining Our Team</h2>
            <div className="w-20 h-1 bg-primary mx-auto" data-id="element-253"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-254">
            {[{
            icon: <TrendingUpIcon size={32} className="text-primary" data-id="element-255" />,
            title: 'Unlimited Growth',
            description: "There is no ceiling on your income, influence, or advancement. If you want more, you'll have the platform to achieve it."
          }, {
            icon: <GraduationCapIcon size={32} className="text-primary" data-id="element-256" />,
            title: 'Continuous Learning',
            description: "From foundational training to advanced certifications, you'll have access to world-class resources that keep you sharp, relevant, and confident."
          }, {
            icon: <AwardIcon size={32} className="text-primary" data-id="element-257" />,
            title: 'Recognition & Rewards',
            description: "Your hard work doesn't go unnoticed. Earn MDRT qualifications, leadership awards, incentive trips, and performance-based bonuses."
          }, {
            icon: <UsersIcon size={32} className="text-primary" data-id="element-258" />,
            title: 'Supportive Community',
            description: "You're never alone. Join a team that celebrates wins, supports growth, and builds each other up—personally and professionally."
          }].map((benefit, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-card text-center" data-id="element-259">
                <div className="bg-primary/10 p-4 rounded-full inline-block mb-4" data-id="element-260">
                  {benefit.icon}
                </div>
                <h3 className="font-bold mb-3 text-lg text-black" data-id="element-261">
                  {benefit.title}
                </h3>
                <p className="text-black text-sm leading-relaxed" data-id="element-262">
                  {benefit.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Testimonials - Simplified without images */}
      <section className="py-16" data-id="element-263">
        <div className="container mx-auto px-4" data-id="element-264">
          <div className="text-center mb-12" data-id="element-265">
            <h2 className="font-bold mb-4" data-id="element-266">What Our Team Members Say</h2>
            <div className="w-20 h-1 bg-primary mx-auto" data-id="element-267"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-268">
            {[{
            quote: "Joining Magnavera Group was the best career decision I've made. The training, mentorship, and supportive environment have helped me grow both professionally and personally.",
            name: 'Sarah Chen',
            role: 'Financial Advisor, 5 years with Magnavera'
          }, {
            quote: 'What I appreciate most about being part of this team is the culture of excellence and the emphasis on continuous learning. Every day brings new opportunities to grow.',
            name: 'Michael Tan',
            role: 'Senior Financial Consultant, 8 years with Magnavera'
          }].map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-lg border border-gray-100" data-id="element-269">
                <p className="italic mb-6 text-gray-700 leading-relaxed text-lg" data-id="element-270">
                  "{testimonial.quote}"
                </p>
                <p className="text-gray-900 font-semibold" data-id="element-271">
                  — {testimonial.name}
                </p>
                <p className="text-gray-600 text-sm mt-1" data-id="element-272">{testimonial.role}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ Preview */}
      <section className="py-16 bg-background" data-id="element-273">
        <div className="container mx-auto px-4 text-center" data-id="element-274">
          <h2 className="font-bold mb-6" data-id="element-275">
            Have Questions About a Career With Us?
          </h2>
          <p className="text-text-secondary max-w-2xl mx-auto mb-8" data-id="element-276">
            Check out our frequently asked questions to learn more about what
            it's like to be a Financial Representative.
          </p>
          <Button href="/faq" variant="secondary" className="group" data-id="element-277">
            View Career FAQs
            <ArrowRightIcon size={16} className="ml-2 group-hover:translate-x-1 transition-transform duration-200" data-id="element-278" />
          </Button>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="bg-primary py-16" data-id="element-279">
        <div className="container mx-auto px-4 text-center" data-id="element-280">
          <h2 className="text-white font-bold mb-4" data-id="element-281">
            Ready to Start Your Journey?
          </h2>
          <p className="text-white opacity-90 max-w-2xl mx-auto mb-8" data-id="element-282">
            Take the first step towards a rewarding career helping others
            achieve financial freedom.
          </p>
          <Button href="https://www.greateasternlife.com/sg/en/careers/financial-representative/apply-now.html" target="_blank" rel="noopener noreferrer" variant="secondary" className="bg-white text-primary" data-id="element-283">
            Apply Now
          </Button>
        </div>
      </section>
    </div>;
};
export default Careers;